import _extends from "@babel/runtime/helpers/extends";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../store";
import { Divider, Spin } from "antd";
import { PluginUpdateForm, PluginUpdateLicenseList } from ".";
import { _i, __ } from "../../utils";
const PluginUpdateErrorNotice = observer(({
  slug
}) => {
  var _error$responseJSON;

  const error = useStores().pluginUpdateStore.pluginUpdateFetchErrors.get(slug);
  const errorMessage = error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "notice notice-error inline below-h2 notice-alt",
    style: {
      margin: "20px 0"
    }
  }, /*#__PURE__*/React.createElement("p", null, _i(__("Something has gone wrong%s. It could be that you have configured your WordPress instance in such a way that you have blocked the WordPress REST API. Find out how to deal with this {{a}}here{{/a}}.", errorMessage ? " (".concat(errorMessage, ")") : ""), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/knowledge-base/wordpress-rest-api-does-not-respond/"),
      target: "_blank",
      rel: "noreferrer"
    })
  })));
});
/**
 * Embed the license form and list of activated licenses into your app.
 * Please consider, that this embed does not provide any buttons, please provide
 * them yourself with `<button form="license-form-$slug"`>
 */

const PluginUpdateEmbed = observer(({
  formProps = {},
  listProps = {},
  slug
}) => {
  const {
    pluginUpdateStore
  } = useStores();
  const {
    busy,
    pluginUpdates,
    pluginUpdateFetchErrors
  } = pluginUpdateStore;
  const pluginUpdate = pluginUpdates.get(slug);
  const showHeadline = (pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.unlicensedEntries.length) > 0 && (pluginUpdate === null || pluginUpdate === void 0 ? void 0 : pluginUpdate.licensedEntries.length) > 0;
  useEffect(() => {
    try {
      pluginUpdateStore.fetchPluginUpdate(slug);
    } catch (e) {// Silence is golden.
    }
  }, [slug]);
  return pluginUpdateFetchErrors.get(slug) ? /*#__PURE__*/React.createElement(PluginUpdateErrorNotice, {
    slug: slug
  }) : busy || !pluginUpdate ? /*#__PURE__*/React.createElement(Spin, {
    spinning: true
  }) : /*#__PURE__*/React.createElement("div", null, showHeadline && /*#__PURE__*/React.createElement(Divider, {
    type: "horizontal",
    orientation: "left",
    style: {
      marginTop: 0
    }
  }, __("Not yet licensed")), /*#__PURE__*/React.createElement(PluginUpdateForm, _extends({}, formProps, {
    pluginUpdate: pluginUpdate
  })), showHeadline && /*#__PURE__*/React.createElement(Divider, {
    type: "horizontal",
    orientation: "left"
  }, __("Already licensed")), pluginUpdate.licensedEntries.length > 0 && /*#__PURE__*/React.createElement(PluginUpdateLicenseList, _extends({}, listProps, {
    pluginUpdate: pluginUpdate
  })));
});
export { PluginUpdateErrorNotice, PluginUpdateEmbed };